import React, { cloneElement, FC } from 'react'
import { IconButton, IconButtonProps } from '@chakra-ui/react'
import { useColor } from '../../theme'

interface ITableActionIconButtonProps {
  'aria-label': IconButtonProps['aria-label'],
  icon: IconButtonProps['icon'],
  id: IconButtonProps['id'],
  onClick: IconButtonProps['onClick'],
  title?: IconButtonProps['title'],
}

export const TableActionIconButton: FC<ITableActionIconButtonProps> = ({ icon, ...restProps }) => {
  const iconColor = useColor({ nuance: 6, palette: 'text' })

  const hasBoxSizeProp = icon?.props?.boxSize != null

  const clonedIcon =
    icon && !hasBoxSizeProp ? cloneElement(icon, { boxSize: 4 }) : icon

  return (
    <IconButton
      _focus={{ background: 'inherit' }}
      _focusWithin={{ background: 'inherit' }}
      _hover={{
        background: 'inherit',
        opacity: 0.5,
      }}
      backgroundColor="inherit"
      color={iconColor}
      height="full"
      icon={clonedIcon}
      isRound
      variant="tertiary"
      {...restProps}
    />
  )
}
